export const SHOPPING_CART_SET_DELIVERY = 'SHOPPING_CART_SET_DELIVERY';
